import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  Drawer,
  Button,
  Radio,
  Space,
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Upload,
  InputNumber,
  Checkbox,
  Tooltip,
} from "antd";
import _, { values } from "lodash";
import moment from "moment";
import { LanguageContext } from "../../../context/LanguageContext";
import { CheckCircleFilled } from "@ant-design/icons";
import { professionalAction } from "../../../_actions";

const { Option } = Select;
const { forwardRef, useRef, useImperativeHandle } = React;
export const BasicInformation = forwardRef((props, ref) => {
  console.log("props", props);
  const [form] = Form.useForm();
  const [citySelected, SetCitySelected] = useState(false);
  const [stateSelected, SetStateSelected] = useState(false);
  const [selecteusStates, setSelectedStates] = useState();
  const [condition, setCondition] = useState();
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [dharm, SetDharm] = useState([]);
  const [district, seDistrict] = useState([]);
  const [crimeType, SetCrimeType] = useState([]);
  const [ishistorySheeter, SetIshistorySheeter] = useState(undefined);
  const [isGunda, setGunda] = useState(undefined);
  const [bothAccused, SetbothAccused] = useState(null);
  const [checked, setChecked] = useState(false);
  const [petrollingChecked, setPetrollingChecked] = useState(false);
  const [petrolling, setPetrolling] = useState(false);
  const [type, setType] = useState(undefined);
  const { language, setLanguage, t } = useContext(LanguageContext);
  // const [selectedStateId,setSelectedStateId] = useState();
  //  const dispatch = useDispatch(); // call hook and get dispatch
  const [inputField, setInputField] = useState({
    address: "",
    age: "",
    cast: "",
    city: "",
    district: "",
    mobileno: "",
    name: "",
    religion: "",
    state: "",
  });

  const applyRadioFieldValue = (fieldName, value, validValues, stateSetter) => {
    if (validValues.includes(Number(value))) {
      const numericValue = Number(value);
      form.setFieldsValue({ [fieldName]: numericValue });
      stateSetter(numericValue);
      return numericValue;
    }
    form.resetFields([fieldName]);
    stateSetter(undefined);
    return undefined;
  };

  const clearGundaFields = () => {
    form.resetFields(["is_gunda", "gunda_date"]);
    setGunda(undefined);
  };

  const clearHistoryFields = () => {
    form.resetFields(["historySheeter", "history_date"]);
    SetIshistorySheeter(undefined);
  };

  const applyTypeRadioValues = (selectedType, data = {}) => {
    clearGundaFields();
    clearHistoryFields();
    if (selectedType === "history") {
      const historyValue = applyRadioFieldValue(
        "historySheeter",
        data?.historySheeter,
        [1, 2, 3],
        SetIshistorySheeter,
      );
      if (historyValue === 1 || historyValue === 3) {
        form.setFieldsValue({
          history_date: data?.history_date
            ? moment(data.history_date)
            : undefined,
        });
      } else {
        form.resetFields(["history_date"]);
      }
    } else if (selectedType === "gunda") {
      const gundaValue = applyRadioFieldValue(
        "is_gunda",
        data?.is_gunda,
        [1, 2],
        setGunda,
      );
      if (gundaValue === 1) {
        form.setFieldsValue({
          gunda_date: data?.gunda_date ? moment(data.gunda_date) : undefined,
        });
      } else {
        form.resetFields(["gunda_date"]);
      }
    }
  };

  console.log("condition", condition);
  const onFinish = (values) => {
    console.log("values", values);
    let obj = {
      ...values,
      districtName: getDistrictName(values.district),
      cityName: getCityName(values.city),
      petrolling_checked: petrolling,
      // current_condition_date: values.current_condition_date
      //   ? moment(values.current_condition_date).format("DD/mm/yyyy")
      //   : null,
      // history_date:form.getFieldValue(['history_date'])?form.getFieldValue(['history_date']):null
      // historySheeter:ishistorySheeter===1?true:ishistorySheeter===2?false:true,
      // bothCriminal:ishistorySheeter===3?true:false
    };

    props.basicInformationFinish(obj);
    // props.uploadImage(fileList);
  };

  useImperativeHandle(ref, () => ({
    onFinish() {
      form.submit();
    },
  }));

  const getStatesWiseCityData = (id) => {
    setCities([]);
    SetCitySelected(false);
    professionalAction.getStatesWiseCityData(id).then((res) => {
      setCities(res.pc_citiesData);
      if (res.pc_citiesData.length > 0) {
        SetCitySelected(true);
      }
    });
  };
  useEffect(() => {
    if (selecteusStates) {
      getStatesWiseCityData(selecteusStates);
    }
  }, [selecteusStates]);

  useEffect(
    (res) => {
      if (
        props.dataStates &&
        props.dataStates.pc_countrystates &&
        props.dataStates.pc_countrystates
      ) {
        setStates([...props.dataStates.pc_countrystates]);
      }
      // if (
      //   props.dataStates &&
      //   props.dataStates.pc_cities &&
      //   props.dataStates.pc_cities
      // ) {
      //   setCities([...props.dataStates.pc_cities]);
      // }
      if (
        props.dataStates &&
        props.dataStates.pc_dharms &&
        props.dataStates.pc_dharms
      ) {
        SetDharm([...props.dataStates.pc_dharms]);
      }
      if (
        props.dataStates &&
        props.dataStates.pc_crimetypes &&
        props.dataStates.pc_crimetypes
      ) {
        SetCrimeType([...props.dataStates.pc_crimetypes]);
      }
    },
    [props.dataStates],
  );

  useEffect(
    (res) => {
      console.log(
        "props.basicInformationData",
        props.basicInformationData,
        props.wantedHistory,
      );
      form.setFieldsValue({
        current_condition: "",
      });
      if (props.basicInformationData && props.basicInformationData.length) {
        // setInputField(props.basicInformationData[0]);
        SetCitySelected(true);
        SetStateSelected(true);

        onCityChange(props.basicInformationData[0].city);
        const {
          type: _type,
          historySheeter: _historySheeter,
          history_date: _historyDate,
          is_gunda: _isGunda,
          gunda_date: _gundaDate,
          ...basicFormValues
        } = props.basicInformationData[0];

        form.setFieldsValue({
          ...basicFormValues,
          toplus:
            props.basicInformationData[0].toplus == 0 ||
            props.basicInformationData[0].toplus == null
              ? false
              : true,
          petrolling_checked:
            props.basicInformationData[0].petrolling_checked == 0 ||
            props.basicInformationData[0].petrolling_checked == null
              ? false
              : true,
          heading: JSON.parse(
            "[" + props.basicInformationData[0].heading + "]",
          ),
        });

        props.basicInformationData &&
          setPetrolling(
            props.basicInformationData[0].petrolling_checked == 0 ||
              props.basicInformationData[0].petrolling_checked == null
              ? false
              : true,
          );
        if (props.basicInformationData[0].gunhaCount > 1) {
          setChecked(true);
        }
      }

      if (props.gunhaInfor && props.gunhaInfor.length > 1) {
        setChecked(true);
      }

      if (props.wantedHistory && props.wantedHistory.length) {
        const wantedHistory = props.wantedHistory[0];
        form.setFieldsValue({
          current_condition: wantedHistory?.current_condition
            ? wantedHistory.current_condition
            : "",
          current_condition_date:
            wantedHistory?.current_condition_date &&
            wantedHistory?.current_condition_date !== "0000-00-00"
              ? moment(wantedHistory.current_condition_date)
              : null,
        });
      }
      if (props?.basicInformationData[0]) {
        setSelectedStates(props?.basicInformationData[0].state);
      }
    },
    [props.basicInformationData[0], props.wantedHistory[0]],
  );
  useEffect(() => {
    if (props?.wantedHistory?.length > 0) {
      const data = props.wantedHistory[0];
      const historyValue = [1, 2, 3].includes(Number(data?.historySheeter))
        ? Number(data.historySheeter)
        : undefined;
      const gundaValue = [1, 2].includes(Number(data?.is_gunda))
        ? Number(data.is_gunda)
        : undefined;
      const selectedType =
        data.type === "history" || data.type === "gunda"
          ? data.type
          : historyValue !== undefined
            ? "history"
            : gundaValue !== undefined
              ? "gunda"
              : undefined;

      if (selectedType === "history") {
        setType("history");
        form.setFieldsValue({ type: "history" });
        applyTypeRadioValues("history", data);
      } else if (selectedType === "gunda") {
        setType("gunda");
        form.setFieldsValue({ type: "gunda" });
        applyTypeRadioValues("gunda", data);
      } else {
        setType(undefined);
        clearGundaFields();
        clearHistoryFields();
        form.setFieldsValue({ type: undefined });
      }
    } else {
      setType(undefined);
      clearGundaFields();
      clearHistoryFields();
      form.setFieldsValue({ type: undefined });
    }
  }, [props.wantedHistory]);

  useEffect(
    (res) => {
      if (props.dataStates && props.dataStates.basicDistricts) {
        // setInputField(props.basicInformationData[0]);
        seDistrict([...props.dataStates.basicDistricts]);
      }
    },
    [props.dataStates && props.dataStates.basicDistricts],
  );

  useEffect(
    (res) => {
      if (props.resetBasicForm) {
        form.resetFields();
      }
    },
    [props.resetBasicForm],
  );

  const onCityChange = (value) => {
    clearDistrictSelected();
    SetCitySelected(true);
    props.onCityChange(value, 1);
  };
  const onStateChange = (value) => {
    console.log("value", value);
    SetStateSelected(true);
    setSelectedStates(value);
    form.resetFields(["city"]);
    form.resetFields(["district"]);
  };
  const clearDistrictSelected = () => {
    form.resetFields(["district"]);
  };

  const onhistorySheeterChange = (e) => {
    SetIshistorySheeter(e.target.value);
  };

  const onGundaChange = (e) => {
    setGunda(e.target.value);
  };
  const getDistrictName = (id) => {
    const { basicDistricts } = props.dataStates;
    if (basicDistricts && basicDistricts.length) {
      return (
        _.filter(basicDistricts, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(basicDistricts, function (o) {
          return o.id === id;
        })[0].DistrictName
      );
    }
  };
  const getCityName = (id) => {
    if (cities && cities.length) {
      return (
        _.filter(cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  const onChangePetrolling = (e) => {
    setPetrolling(e.target.checked);
  };

  const disableFutureDates = (current) => {
    // Can not select days after today
    return current && current > moment().endOf("day");
  };
  console.log("cities", cities);
  console.log("states", states);
  console.log("selected states", selecteusStates);

  return (
    <div>
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Row gutter={16}>
          <Col span={16}>
            <Form.Item
              name="heading"
              label="लघु शीर्षक"
              rules={[
                { required: true, message: "Please select a Crime Head." },
              ]}
            >
              <Select
                placeholder="Please select Crime Type"
                mode="multiple"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {crimeType &&
                  crimeType.length &&
                  crimeType.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.crimetype}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <Form.Item
              label="गस्त दरम्यान चेक करायचे का?"
              className="rememberMeCheckbox"
              name="petrolling_checked"
              valuePropName="petrolling_checked"
            >
              <Checkbox
                name="petrolling_checked"
                onChange={onChangePetrolling}
                checked={petrolling}
              >
                {" "}
                होय
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>
        {/* hide  */}
        {/* <Col span={6}>
            <Form.Item
              label={t("is_2Plus_accused")}
              className="rememberMeCheckbox"
              name="toplus"
              valuePropName="toplus"
            >
              <Checkbox disabled checked={checked} name="toplus">
                {" "}
                होय
              </Checkbox>
            </Form.Item>
          </Col> */}
        <Row gutter={[16, 16]}>
          {/* History Sheeter */}
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              name="type"
              label={t("historySheeterGunda")}
              rules={[{ required: true, message: "Please select option" }]}
            >
              <Select
                placeholder={t("please_select_an_option")}
                optionFilterProp="children"
                onChange={(value) => {
                  setType(value);
                  requestAnimationFrame(() => {
                    if (value === "history" || value === "gunda") {
                      applyTypeRadioValues(
                        value,
                        props.wantedHistory?.[0] || {},
                      );
                    } else {
                      clearGundaFields();
                      clearHistoryFields();
                    }
                  });
                }}
              >
                <Option value="">{t("please_select_an_option")}</Option>
                <Option value="history">{t("history_sheeter")}</Option>
                <Option value="gunda">{t("gunda")}</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            {type === "history" && (
              <Form.Item
                key="history-sheeter-radio"
                preserve={false}
                name="historySheeter"
                label={t("is_history_sheeter")}
                rules={[
                  { required: true, message: "Please select historySheeter" },
                ]}
              >
                <Radio.Group onChange={onhistorySheeterChange}>
                  <Radio value={1}>{t("yes")}</Radio>
                  <Radio value={2}>{t("no")}</Radio>
                  <Radio value={3}>{t("both")}</Radio>
                </Radio.Group>
              </Form.Item>
            )}
            {type === "gunda" && (
              <Form.Item
                key="gunda-radio"
                preserve={false}
                name="is_gunda"
                label={t("isInGundaRegister")}
                rules={[
                  { required: true, message: "Please select historySheeter" },
                ]}
              >
                <Radio.Group onChange={onGundaChange}>
                  <Radio value={1}>{t("yes")}</Radio>
                  <Radio value={2}>{t("no")}</Radio>
                </Radio.Group>
              </Form.Item>
            )}
          </Col>

          {/* History Date */}
          {(ishistorySheeter === 1 || ishistorySheeter === 3) && (
            <Col xs={24} sm={12} md={6}>
              <Form.Item
                preserve={false}
                name="history_date"
                label={t("history_sheeter_entry_date")}
                rules={[
                  { required: true, message: "Please select history date" },
                ]}
              >
                <DatePicker style={{ width: "100%" }} inputReadOnly />
              </Form.Item>
            </Col>
          )}
          {isGunda === 1 && (
            <Col xs={24} sm={12} md={6}>
              <Form.Item
                preserve={false}
                name="gunda_date"
                label={t("gund_sheeter_entry_date")}
                rules={[
                  { required: true, message: "Please select gunda date" },
                ]}
              >
                <DatePicker style={{ width: "100%" }} inputReadOnly />
              </Form.Item>
            </Col>
          )}

          {/* Current Status */}
        </Row>

        <Row gutter={16}>
          <Col xs={24} sm={12} md={5}>
            <Form.Item name="current_condition" label={t("current_status")}>
              <Select placeholder="निवडा" optionFilterProp="children">
                <Option value="">निवडा</Option>
                <Option value="पाहिजे">पाहिजे</Option>
                <Option value="फरार">फरार</Option>
              </Select>
            </Form.Item>
          </Col>

          {/* Conditional Date */}
          <Col xs={24} sm={12} md={5}>
            <Form.Item
              shouldUpdate={(prev, curr) =>
                prev.current_condition !== curr.current_condition
              }
            >
              {({ getFieldValue }) => {
                const condition = getFieldValue("current_condition");

                if (!condition) return null;

                const label =
                  condition === "पाहिजे"
                    ? t("when_to_patrol")
                    : t("when_to_patrol_absconding");

                return (
                  <Form.Item name="current_condition_date" label={label}>
                    <DatePicker
                      style={{ width: "100%" }}
                      inputReadOnly
                      disabledDate={disableFutureDates}
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="name"
              label={t("accused_name")}
              rules={[
                { required: true, message: "Please enter  name" },
                // {
                //   pattern: new RegExp(/^[-_a-zA-Z0-9.]+(?:\s[-_a-zA-Z0-9.]+)*$/i),
                //   message: "Only enter valid format allowed!"
                // }
              ]}
            >
              <Input
                onPaste={(e) => {
                  e.preventDefault();

                  let text = e.clipboardData.getData("text");

                  // Remove commas
                  text = text.replace(/,/g, "");

                  // Keep only English, Marathi/Hindi letters and spaces
                  text = text.replace(/[^A-Za-z\u0900-\u097F\s]/g, "");

                  // Remove extra spaces
                  text = text.replace(/\s+/g, " ").trim();

                  document.execCommand("insertText", false, text);
                }}
                onKeyPress={(e) => {
                  if (!/[A-Za-z\u0900-\u097F\s]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Form.Item
                name="age"
                label={t("accused_age")}
                rules={[{ required: true, message: "Please enter age" }]}
              >
                <InputNumber
                  onKeyPress={(event) => {
                    if (!/^[0-9]$/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onPaste={(event) => {
                    event.preventDefault();
                  }}
                  style={{ width: "100%" }}
                  max={100}
                  min={5}
                  placeholder="Please enter age"
                  disabled={props?.is_document_verified === true}
                />
              </Form.Item>

              {props?.is_document_verified && (
                <Tooltip
                  placement="top"
                  title={
                    <>
                      आरोपीचे वय खालील प्रमाणे घेतले आहे <br />
                      ओळखपत्र चे नाव : Driving License <br />
                      ओळखपत्र क्रमांक :{" "}
                      {props.basicInformationData[0]?.document_number || "-"}
                    </>
                  }
                >
                  <CheckCircleFilled
                    style={{
                      fontSize: "20px",
                      color: "#52c41a",
                      cursor: "pointer",
                      flexShrink: 0,
                    }}
                  />
                </Tooltip>
              )}
            </div>
          </Col>
          <Col span={8}>
            <Form.Item
              name="gender"
              label={t("gender")}
              rules={[{ required: true, message: "Please select a gender" }]}
            >
              <Select placeholder="निवडा" optionFilterProp="children">
                <Option value="">निवडा</Option>
                <Option value="female">{t("female")}</Option>
                <Option value="male">{t("male")}</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="state"
              label={t("state")}
              rules={[{ required: true, message: "Please select a state" }]}
            >
              <Select
                placeholder="Please select a state"
                optionFilterProp="children"
                onChange={onStateChange}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
                //placeholder="Please select an state"
              >
                {states &&
                  states.length &&
                  states.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.state}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="city"
              label={t("component")}
              rules={[{ required: true, message: "Please select a City" }]}
            >
              <Select
                onChange={onCityChange}
                placeholder="Please select a City"
                disabled={!stateSelected}
                rules={[{ required: true, message: "Please select a City" }]}
              >
                {cities &&
                  cities.length &&
                  cities.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.City}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="district"
              label={t("police_station_of_the_accused_residence")}
              rules={[{ required: true, message: "Please sleect a district" }]}
            >
              <Select
                optionFilterProp="children"
                placeholder="Please select a district"
                disabled={!citySelected}
              >
                {district &&
                  district.length &&
                  district.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.DistrictName}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              name="religion"
              label={t("religion")}
              rules={[{ required: true, message: "Please select a religion" }]}
            >
              <Select
                optionFilterProp="children"
                placeholder="Please select a religion"
              >
                {dharm &&
                  dharm.length &&
                  dharm.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.DharmName}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="cast"
              label={t("cast")}
              rules={[{ message: "Please enter the caste" }]}
            >
              <Input
                onKeyPress={(e) => {
                  if (!/[A-Za-z\u0900-\u097F\s]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                placeholder="Please enter the caste"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="mobileNumber"
              label={t("mobile_number")}
              rules={[
                {
                  message: "Please enter a valid 10-digit mobile number",
                },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Please enter a valid 10-digit mobile number",
                },
              ]}
            >
              <Input
                maxLength={10}
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onPaste={(event) => {
                  event.preventDefault();
                }}
                placeholder="Please enter a valid mobile number"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              name="address"
              label={t("accused_address")}
              rules={[
                {
                  required: true,
                  message: "Please enter the address",
                },
              ]}
            >
              <Input.TextArea rows={4} placeholder="Please enter the address" />
            </Form.Item>
          </Col>
          {/* <Form.Item>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
            </Form.Item> */}
        </Row>
      </Form>
    </div>
  );
});
